import { render, staticRenderFns } from "./hotel-initialization.vue?vue&type=template&id=4cbcc290&scoped=true"
import script from "./hotel-initialization.vue?vue&type=script&lang=js"
export * from "./hotel-initialization.vue?vue&type=script&lang=js"
import style0 from "./hotel-initialization.vue?vue&type=style&index=0&id=4cbcc290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcc290",
  null
  
)

export default component.exports